// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_lTy","cls2":"ReferenceEvaluationPage-cls2_Rzw ReferenceEvaluationPage-cls1_lTy"};